export default __webpack_public_path__ + "static/media/tunnel.52df385c.svg";